import { PartnersOrderState } from '@store/partners-order/PartnersOrderState';
import { PartnerOrderDef } from '@api/types/PartnerOrderDef';
import { Purchase } from '@features/gtm/types/Purchase';
import { Item } from '@features/gtm/types/Item';
import { generateGuid } from '@components/utils';



export const convertToPartnerOrderDef = (state: PartnersOrderState): PartnerOrderDef | null => {
	if (!state.customer) return null;
	if (process.env.SHOW_COMPANY_REGISTRATION_ID === 'TRUE' && !state.registrationNumber) return null;
	if (!state.vatnumber) return null;
	if (!state.payment) return null;
	if (!state.delivery) return null;
	if (!state.country) return null;

	return {
		customer: state.customer,
		email: state.email,
		phoneNumber: state.phoneNumber,
		
		street: state.street,
		city: state.city,
		postalCode: state.postalCode,
		invoiceStreet: state.invoiceStreet,
		invoiceCity: state.invoiceCity,
		invoicePostalCode: state.invoicePostalCode,
		
		registrationNumber: state.registrationNumber,
		vatnumber: state.vatnumber,
		message: state.message,
		paymentType: state.payment.id,
		delivery: state.delivery.id,
		dispatchPoint: state.dispatchPoint ? state.dispatchPoint : undefined,

		catL: state.orderedCatsUnits.sizeL,
		catM: state.orderedCatsUnits.sizeM,
		catS: state.orderedCatsUnits.sizeS,

		catCollarL: state.orderedCatsCollarUnits.sizeL,
		catCollarM: state.orderedCatsCollarUnits.sizeM,
		catCollarS: state.orderedCatsCollarUnits.sizeS,

		dogS: state.orderedDogsUnits.sizeS,
		dogM: state.orderedDogsUnits.sizeM,
		dogL1: state.orderedDogsUnits.sizeL1,
		dogL2: state.orderedDogsUnits.sizeL2,
		dogXL1: state.orderedDogsUnits.sizeXL1,
		dogXL2: state.orderedDogsUnits.sizeXL2,
		dogXXL1: state.orderedDogsUnits.sizeXXL1,
		dogXXL2: state.orderedDogsUnits.sizeXXL2,
		dog3XL1: state.orderedDogsUnits.size3XL1,
		dog3XL2: state.orderedDogsUnits.size3XL2,
		dog4XL1: state.orderedDogsUnits.size4XL1,
		dog4XL2: state.orderedDogsUnits.size4XL2,
		dog5XL: state.orderedDogsUnits.size5XL,

		dogXLMini: state.orderedDogsUnits.sizeXLMini,
		dog4XLMini: state.orderedDogsUnits.size4XLMini,
		dog3XLMini: state.orderedDogsUnits.size3XLMini,
		dog2XLMini: state.orderedDogsUnits.size2XLMini,

		testSamples: state.testSamples,
		country: state.country,
	}
}



export const convertToPartnerOrderPurchase = (state: PartnersOrderState): Purchase => {

	let items: Item[] = [];

	// cats
	if (state.orderedCatsUnits.sizeL > 0) items.push(generateCatItem('L', state.orderedCatsUnits.sizeL));
	if (state.orderedCatsUnits.sizeM > 0) items.push(generateCatItem('M', state.orderedCatsUnits.sizeM));
	if (state.orderedCatsUnits.sizeS > 0) items.push(generateCatItem('S', state.orderedCatsUnits.sizeS));

 	// cats collar
	if (state.orderedCatsCollarUnits.sizeL > 0) items.push(generateCatCollarItem('L', state.orderedCatsCollarUnits.sizeL));
	if (state.orderedCatsCollarUnits.sizeM > 0) items.push(generateCatCollarItem('M', state.orderedCatsCollarUnits.sizeM));
	if (state.orderedCatsCollarUnits.sizeS > 0) items.push(generateCatCollarItem('S', state.orderedCatsCollarUnits.sizeS));

	// dogs
	if (state.orderedDogsUnits.sizeS > 0) items.push(generateDogItem('S', state.orderedDogsUnits.sizeS));
	if (state.orderedDogsUnits.sizeM > 0) items.push(generateDogItem('M', state.orderedDogsUnits.sizeM));
	if (state.orderedDogsUnits.sizeL1 > 0) items.push(generateDogItem('L1', state.orderedDogsUnits.sizeL1));
	if (state.orderedDogsUnits.sizeL2 > 0) items.push(generateDogItem('L2', state.orderedDogsUnits.sizeL2));
	if (state.orderedDogsUnits.sizeXL1 > 0) items.push(generateDogItem('XL1', state.orderedDogsUnits.sizeXL1));
	if (state.orderedDogsUnits.sizeXL2 > 0) items.push(generateDogItem('XL2', state.orderedDogsUnits.sizeXL2));
	if (state.orderedDogsUnits.sizeXXL1 > 0) items.push(generateDogItem('XXL1', state.orderedDogsUnits.sizeXXL1));
	if (state.orderedDogsUnits.sizeXXL2 > 0) items.push(generateDogItem('XXL2', state.orderedDogsUnits.sizeXXL2));
	if (state.orderedDogsUnits.size3XL1 > 0) items.push(generateDogItem('3XL1', state.orderedDogsUnits.size3XL1));
	if (state.orderedDogsUnits.size3XL2 > 0) items.push(generateDogItem('3XL2', state.orderedDogsUnits.size3XL2));
	if (state.orderedDogsUnits.size4XL1 > 0) items.push(generateDogItem('4XL1', state.orderedDogsUnits.size4XL1));
	if (state.orderedDogsUnits.size4XL2 > 0) items.push(generateDogItem('4XL2', state.orderedDogsUnits.size4XL2));
	if (state.orderedDogsUnits.size5XL > 0) items.push(generateDogItem('5XL', state.orderedDogsUnits.size5XL));

	if (state.orderedDogsUnits.sizeXLMini > 0) items.push(generateDogItem('XLMini', state.orderedDogsUnits.sizeXLMini));
	if (state.orderedDogsUnits.size4XLMini > 0) items.push(generateDogItem('4XLMini', state.orderedDogsUnits.size4XLMini));
	if (state.orderedDogsUnits.size3XLMini > 0) items.push(generateDogItem('3XLMini', state.orderedDogsUnits.size3XLMini));
	if (state.orderedDogsUnits.size2XLMini > 0) items.push(generateDogItem('2XLMini', state.orderedDogsUnits.size2XLMini));

	// test samples
	if (state.testSamples) items.push({
		item_id: 'testovaci_sada',
		item_name: 'testovaci_sada',
		item_category: 'testovaci_sada',
	});

	return {
		transaction_id: generateGuid(),
		shipping: state.delivery && state.payment ? state.delivery.price + state.payment.price : null,
		items: items,
	}
}


function generateCatItem(size: string, quantity: number) {
	return ({
		item_id: 'limec_kocka',
		item_name: 'limec_kocka',
		item_category: 'limec_kocka',
		item_variant: size,
		quantity: quantity,
	})
}

function generateCatCollarItem(size: string, quantity: number) {
	return ({
		item_id: 'limec_jicnova_sonda',
		item_name: 'limec_jicnova_sonda',
		item_category: 'limec_jicnova_sonda',
		item_variant: size,
		quantity: quantity,
	})
}

function generateDogItem(size: string, quantity: number) {
	return ({
		item_id: 'limec_pes',
		item_name: 'limec_pes',
		item_category: 'limec_pes',
		item_variant: size,
		quantity: quantity,
	})
}